(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zg-contact-form"] && !Shopify.designMode) return;
  try {
    
  // After a post Shopify reloads the page at #ContactForm-…. A URL fragment makes browsers skip `autofocus`, and their
  // scroll to the fragment resets focus to the page, so focus the success message or the error list once the page has
  // loaded, unless the shopper has already focused something. Runs on every page; does nothing without a result.
  (() => {
    const focusResult = () => {
      const result = document.querySelector('.zg-contact-form [data-zg-contact-result]');
      if (!(result instanceof HTMLElement)) return;
      const active = document.activeElement;
      if (active && active !== document.body && active !== document.documentElement) return;
      result.focus();
    };
    if (document.readyState === 'complete') {
      focusResult();
    } else {
      window.addEventListener('load', () => requestAnimationFrame(focusResult), { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zg-faq"] && !Shopify.designMode) return;
  try {
    
  // Theme editor: open a question when its block is selected, so its answer is visible while editing.
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target;
    if (item instanceof HTMLDetailsElement && item.classList.contains('zg-faq__item')) {
      item.open = true;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
